import Contact from "@mpa/toolbox/models/Contact";
import type { PartyInfo } from "@mpa/toolbox/models/Party";

import type { Action } from "../../action/Action";
import { PromiseToast } from "../../components/async/PromiseToast";
import Button from "../../components/Button/Button";
import Centered from "../../components/Centered";
import { useDialogConfirm } from "../../components/dialog/useDialogConfirm";
import Divider from "../../components/Divider";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import Spacer from "../../components/space/Spacer";
import { callOutgoingRequest, useOutgoingRequest } from "../../data/tanstack-query";
import { deleteContact, getContact, updateContact } from "../../endpoints/outgoing-requests";
import useSubmit from "../../hooks/useSubmit";
import { usePathParams } from "../../navigation/hooks";
import { goBack } from "../../navigation/location";
import { PartyEditor } from "./components/PartyEditor";
import { contactRoute } from "./navigation";

export default function ContactPage() {
    const { contact: id } = usePathParams(contactRoute);
    const contact = useOutgoingRequest(getContact(id));
    const [onDelete, deletion] = useSubmit(async () => {
        await callOutgoingRequest(deleteContact(id));
        goBack();
    }, [id]);

    const [onEditorDone, edition] = useSubmit(
        async (infos: PartyInfo[]) => {
            const next = new Contact();
            next.id = contact.id;
            next.projet = contact.projet;
            next.createdAt = contact.createdAt;
            next.infos = infos;
            await callOutgoingRequest(updateContact(id, next));
            goBack();
        },
        [id, contact],
    );
    return (
        <LightPageLayout>
            <PromiseToast promise={deletion} message="Contact supprimé" />
            <PromiseToast promise={edition} message="Contact modifié" />
            <PageHeader title="Contact" />
            <PartyEditor infos={contact.infos} onDone={onEditorDone} />
            <DeleteZone label="Supprimer ce contact" onDelete={onDelete} />
        </LightPageLayout>
    );
}

type DeleteZoneProps = {
    label: string;
    onDelete: Action;
};

function DeleteZone(props: DeleteZoneProps) {
    const { label, onDelete } = props;

    const [showDialog, confirmNode] = useDialogConfirm({
        message: "Confirmation de suppression",
        onConfirm: onDelete,
    });

    return (
        <>
            <Spacer scale={9} />
            <Divider />
            <Spacer scale={9} />
            <Centered>
                <Button label={label} action={showDialog} feeling="danger" role="minor" />
            </Centered>
            {confirmNode}
        </>
    );
}
